import { Outlet, createFileRoute } from '@tanstack/react-router';

import { ScanWorkOrderButton } from '../../features/work-orders/scan-work-order-button';

export const Route = createFileRoute('/job-cards')({
  staticData: {
    breadcrumb: 'Job Cards',
    // Legacy's Job Cards pages carried the same scanner as everywhere else: it
    // reads a *work order* QR / pin code, not a job card — there is no job-card
    // QR to scan — so the existing shared button is reused rather than a
    // job-card-specific one being invented.
    headerActions: () => <ScanWorkOrderButton />,
  },
  component: JobCardsLayout,
});

function JobCardsLayout() {
  return <Outlet />;
}
